registerComponent("product-blocks/asa-fidc-singulare-form-modal", async function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * 301 linhas viraram estas. Era o ÚLTIMO `$.validator.addMethod`, a última
 * `jquery.mask` e o último `TweenLite` do site: o jQuery Validate, a tabela de
 * mensagens PT/EN, o `highlight`/`unhighlight`/`errorPlacement`, a máscara de
 * telefone e o `$.ajax` estão todos em `Asa.formulario`; aqui fica só o que é
 * deste modal.
 *
 * ── Abrir e fechar: o que os dois `TweenLite` faziam de verdade ────────────
 *
 * `TweenLite.to($component, .4, {display: 'block'|'none', opacity: …})` — o
 * GSAP escreve `display` no INÍCIO do tween. O root aparecia e sumia NO ATO; o
 * que durava 0,4s era só o `y` do `.wrapper-modal`, e o `opacity` nunca
 * desenhou nada (a folha não dá opacidade inicial ao root: era 1 para 1). Aqui
 * são duas classes — `.is-aberto` (o `display`) e `.is-visivel` (o `transform`)
 * —, em dois passos, porque no mesmo quadro o navegador colapsaria
 * `display: none` e a posição final e a entrada não teria transição.
 *
 * ⚠️ O `onComplete` continua sendo TEMPORIZADOR, e não `transitionend`: no
 * fechamento o root volta a `display: none` no mesmo quadro, e elemento sem
 * caixa NÃO dispara `transitionend` — o ouvinte ficaria pendurado para sempre.
 * `ANIMACAO` é o `.4` dos dois tweens, em ms.
 *
 * ── `body.modal-open` não trava rolagem nenhuma ────────────────────────────
 *
 * ⚠️ Reproduzido à letra, e é DEFEITO DE PRODUÇÃO: a classe que trava a
 * rolagem por trás de um modal, no `_legacy.less`, é `modal-opened` — com
 * "ed" —, e é a que `modals/modal-investir`, `modal-docs` e `modal-faq`
 * escrevem. Este arquivo escreve `modal-open`, que não tem regra nenhuma no
 * bundle (`grep modal-open public/assets/site/styles/main.min.css` devolve só
 * `modal-opened`): com o modal FIDC aberto, a página continua rolando atrás
 * dele desde 2023. Corrigir aqui mudaria a tela sem decisão do responsável —
 * está em "Achados para o responsável", como o `.institucional` do 8a.
 *
 * ── O que MUDA de comportamento, e por quê ─────────────────────────────────
 *
 * · **422 com erro POR CAMPO não troca de tela.** `api/fidc` valida com
 *   `$request->validate()`, então responde 422 com `errors` — e não 200 com
 *   `error: true`, que é o contrato do `api/contatos`. Em 2020 o 422 caía no
 *   `.fail()` do jQuery e virava a tela de erro genérica, que esconde o
 *   formulário e com ele a mensagem que explicaria o problema (o `max:60` do
 *   nome é o caminho vivo: o cliente não o checa). Mesma decisão do 5c e do
 *   `modals/modal-investir`: mensagem ao lado do campo, formulário no lugar. A
 *   tela de erro continua valendo para tudo o mais.
 * · `keyup` → `input` nos campos (ver `blocks/input`).
 *
 * ── O que NÃO muda ─────────────────────────────────────────────────────────
 *
 * O corpo do POST (nomes e valores MASCARADOS, que é o que o `$form.serialize()`
 * mandava), o destino (`action` do Blade, `url('api/fidc')`, no lugar do
 * `${base}api/fidc` do legado), o `window.open` da Singulare no sucesso e o
 * `origin` que o gatilho passa.
 *
 * ── Achados registrados, reproduzidos como estão ───────────────────────────
 *
 * · `$form.find('label').removeClass('active')` do sucesso NÃO foi transposto:
 *   nada no site escreve `active` em `<label>` e nenhuma folha o estiliza — o
 *   `blocks/input` marca `full` no `.box-input`. Linha morta desde sempre.
 * · O `form.reset()` do sucesso não limpa esse `full`: na reabertura os rótulos
 *   ficam flutuando sobre campos vazios. Era assim em 2020 (o `_input.js` de lá
 *   ouvia `keyup`, que o `reset()` também não dispara) e continua sendo.
 * · O `window.open` depois do `await` pode ser bloqueado como popup. Era igual
 *   em 2020, dentro do `.done()`; é achado, não regressão.
 */

const isEn = (document.documentElement.lang || '').toLowerCase().startsWith('en');
const isPt = !isEn;
const t = (pt, en) => (isEn ? en : pt);

// O `.4` dos dois tweens de 2020, em ms.
const ANIMACAO = 400;

const SINGULARE = 'https://cadastro-prd.singulare.com.br/wm/iportal/auth/newAutoCadastroPortal';

const form = component.querySelector('#form-plataform');
const botaoFechar = component.querySelector('.btn-close-modal');
const botaoEnviar = form.querySelector('[type="submit"]');
const campoOrigem = form.querySelector('input[name="origin"]');
const campoTelefone = form.querySelector('.input-phone input');
const passoDoForm = component.querySelector('.form-step');
const telaErro = component.querySelector('.error-screen');

let temporizador = null;

/*
 | ⚠️ `display: 'block'` na tela de erro, `''` no passo do formulário. O
 | `.show()` do jQuery caía no display padrão da tag quando o `''` não bastava,
 | e `.error-screen` nasce `display: none` NA FOLHA — devolver `''` devolveria
 | o `none` e a tela de erro nunca apareceria, sem erro no console. O
 | `.form-step` sai de display da folha e volta para ele: ali quem escreveu o
 | `none` foi este arquivo. Correção 67, a mesma do `modals/modal-investir`.
 */
const mostrarErro = (visivel) => {
    telaErro.style.display = visivel ? 'block' : 'none';
    passoDoForm.style.display = visivel ? 'none' : '';
};

/* ── Abrir e fechar ─────────────────────────────────────────────────────── */

// Tagueamento (plano v3.1): quando abriu, para o `modal_close`.
let abertoEm = 0;

const abrir = (origem) => {
    window.clearTimeout(temporizador);

    abertoEm = Date.now();
    Asa.track('modal_open', { modal_name: 'singulare', origin: 'platforms_block', method: 'click' });

    campoOrigem.value = origem;

    component.classList.add('is-aberto');

    // Força o layout com o root já visível (estado "fechado" pintado) antes de
    // armar a classe — é o que faz a transição existir.
    void component.offsetWidth;
    requestAnimationFrame(() => component.classList.add('is-visivel'));

    temporizador = window.setTimeout(function () {
        document.body.classList.add('modal-open');
    }, ANIMACAO);

    // O `handleValidation()` do fim do arquivo de 2020: cobre o
    // autopreenchimento do navegador, que já pode ter enchido os campos.
    formulario.atualizarEnvio();
};

const fechar = () => {
    window.clearTimeout(temporizador);

    Asa.track('modal_close', { modal_name: 'singulare', method: 'x', seconds: Math.round((Date.now() - abertoEm) / 1000) });

    component.classList.remove('is-aberto', 'is-visivel');

    temporizador = window.setTimeout(function () {
        document.body.classList.remove('modal-open');

        // Garante que o próximo open mostra o formulário, não a tela de erro
        // (caso o usuário tenha fechado o modal estando em estado de erro).
        mostrarErro(false);
    }, ANIMACAO);
};

document.querySelectorAll('[data-open-modal-form]').forEach(function (gatilho) {
    gatilho.addEventListener('click', function () {
        abrir(gatilho.getAttribute('data-open-modal-form'));
    });
});

botaoFechar.addEventListener('click', fechar);

/*
 | O clique fora, como em 2020: só vale enquanto `body.modal-open` está posta —
 | e ela só entra ANIMACAO ms depois da abertura, que é o que impede o próprio
 | clique do gatilho (que borbulha até o body) de fechar o modal na hora.
 */
document.body.addEventListener('click', function (evento) {
    if (document.body.classList.contains('modal-open') && !evento.target.closest('.box-modal')) {
        fechar();
    }
});

/* ── Botão "Voltar" da tela de erro ─────────────────────────────────────── */

// Volta para o formulário preservando os valores preenchidos para o usuário
// poder tentar de novo. O `removeAttr('disabled')` de 2020 vira
// `atualizarEnvio()`: se o envio chegou a acontecer, a validação já tinha
// passado e o botão destrava do mesmo jeito — mas por medição, não à força.
telaErro.querySelector('.link-back-error').addEventListener('click', function (evento) {
    evento.preventDefault();

    mostrarErro(false);
    formulario.atualizarEnvio();
});

/* ── Formulário ─────────────────────────────────────────────────────────── */

/*
 | A máscara do telefone, a mesma dos outros formulários de 2020.
 |
 | PT: 11 dígitos viram `(00) 00000-0000`, menos do que isso fica em
 | `(00) 0000-00009`. EN: o telefone estrangeiro não tem formato fixo, e 2020 só
 | filtrava os não dígitos em tempo real — uma máscara de N tokens `0` é
 | exatamente esse filtro dentro do mesmo contrato.
 */
const mascaraDoTelefone = isPt
    ? (valor) => (valor.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009')
    : (valor) => '0'.repeat(Math.max(1, valor.replace(/\D/g, '').length));

if (campoTelefone && isEn) {
    campoTelefone.setAttribute('inputmode', 'numeric');
}

/*
 | O `isRequiredFilled` de 2020, e ele é NECESSÁRIO aqui: o
 | `atualizarEnvio` de `Asa.formulario` só olha para campo VISÍVEL (o
 | `ignore: ":hidden"` do jQuery Validate), e o modal nasce `display: none` —
 | sem esta função a lista de obrigatórios sairia vazia no boot, "tudo válido"
 | daria verdadeiro e o botão nasceria DESTRAVADO, contra o `disabled` do Blade.
 */
const habilitarEnvio = () => Array.from(form.querySelectorAll('[required]')).every(function (campo) {
    if (campo.type === 'checkbox' || campo.type === 'radio') {
        return campo.checked;
    }

    return Boolean(campo.value);
});

const formulario = Asa.formulario(form, {
    regras: {
        name: {
            minlength: 3,
        },
        email: {
            email: true,
        },
        phone: {
            minlength: 7,
            // `cellphone: (isPt) ? true : false` — DDD e o 9 na frente são
            // regra brasileira e só valem em pt.
            celular: isPt,
        },
    },
    mensagens: {
        name: {
            required: t('O nome é obrigatório', 'The name is mandatory'),
            minlength: t('O nome deve ter no mínimo 3 caracteres', 'The name must have at least 3 characters'),
        },
        email: {
            required: t('O e-mail é obrigatório', 'The e-mail is mandatory'),
            email: t('E-mail inválido', 'Invalid e-mail'),
        },
        phone: {
            required: t('O celular é obrigatório', 'The cell phone is mandatory'),
            minlength: t('Informe um celular válido.', 'Provide a valid mobile phone number.'),
            celular: t('Informe um celular válido.', 'Provide a valid mobile phone number.'),
        },
        accept_terms: {
            required: t('Você precisa aceitar os termos', 'You need to accept the terms'),
        },
    },
    mascaras: {
        phone: mascaraDoTelefone,
    },
    /*
     | O `highlight`/`unhighlight` de 2020: o checkbox marca a `.box-checkbox`,
     | e não os dois wrappers do `blocks/input`, que ele não tem.
     */
    alvosDoEstado: (campo) => (campo.type === 'checkbox'
        ? [campo.closest('.box-checkbox')].filter(Boolean)
        : [
            campo.closest('[data-component-name="blocks/input"]'),
            campo.closest('.box-input'),
        ].filter(Boolean)),
    /*
     | O `errorPlacement` de 2020: a mensagem do checkbox vai DENTRO da
     | `.msg-error` que o markup já tem (é ela que a folha estiliza), e não
     | numa `label.error` solta depois do input.
     */
    posicionarErro: (campo, rotulo) => {
        if (campo.type !== 'checkbox') {
            return false;
        }

        const caixa = campo.closest('.row-form-checkbox').querySelector('.msg-error');

        caixa.textContent = '';
        caixa.appendChild(rotulo);

        return true;
    },
    habilitarEnvio,
});

/* ── Envio ──────────────────────────────────────────────────────────────── */

form.addEventListener('formulario:enviando', function () {
    botaoEnviar.textContent = t('Enviando...', 'Sending...');
});

/*
 | ⚠️ O rótulo de volta é o de 2020, com o defeito dele: em pt volta "Quero
 | investir", que é o mesmo do Blade, e em en volta "Invest", que NÃO é — o
 | Blade escreve "I want to invest". Depois do primeiro envio o botão em inglês
 | encurta e não volta mais. Reproduzido à letra; está em "Achados para o
 | responsável".
 */
const devolverRotulo = () => {
    botaoEnviar.textContent = t('Quero investir', 'Invest');
};

form.addEventListener('formulario:sucesso', function () {
    devolverRotulo();

    // SUCESSO: abre a Singulare em nova aba, limpa o form e fecha o modal.
    window.open(SINGULARE, '_blank');

    form.reset();
    formulario.limpar();
    fechar();
});

form.addEventListener('formulario:erro', /** @param {CustomEvent} evento */ function (evento) {
    devolverRotulo();

    if (evento.detail && evento.detail.erros) {
        return;
    }

    mostrarErro(true);
});

});
